/** Anonymous-only hint for CloudFront banner spike params. Written by useSyncAnonymousCartEmptyHint. */
export const PERSISTED_CART_EMPTY_KEY = 'willys.anonymousCartEmptyHint';

export const getPersistedCartEmpty = (): boolean | null => {
  if (typeof window === 'undefined') {
    return null;
  }
  try {
    const raw = window.localStorage.getItem(PERSISTED_CART_EMPTY_KEY);
    return raw == null ? null : raw === 'true';
  } catch {
    // localStorage can throw when storage is blocked (Safari private mode).
    return null;
  }
};

export const setPersistedCartEmptyForAnonymous = (isEmpty: boolean): void => {
  if (typeof window === 'undefined') {
    return;
  }
  try {
    window.localStorage.setItem(PERSISTED_CART_EMPTY_KEY, String(isEmpty));
  } catch {
    // Ignore write failures - the hint is best-effort.
  }
};
